import { render, staticRenderFns } from "./HomePrix.vue?vue&type=template&id=cbb744c0"
import script from "./HomePrix.vue?vue&type=script&lang=js"
export * from "./HomePrix.vue?vue&type=script&lang=js"
import style0 from "./HomePrix.vue?vue&type=style&index=0&id=cbb744c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports